import React, { useState } from 'react';
import styled from 'styled-components';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
`;

const DropdownButton = styled.div`
  padding: 0.8rem;
  font-size: 1rem;
  color: #333;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 0 8px rgba(102, 187, 106, 0.2);

  &:focus {
    outline: none;
    border-color: #66bb6a;
  }
`;

const DropdownList = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  max-height: 150px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  z-index: 10;
  transition: max-height 0.3s ease-in-out;
`;

const DropdownItem = styled.div`
  padding: 0.8rem;
  font-size: 1rem;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f2f2f2;
  }
`;

const Arrow = styled.span`
  color: #66bb6a;
`;

const CustomDropdown = ({ options, selectedOption, onOptionSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const handleSelect = (option) => {
      onOptionSelect(option);
      setIsOpen(false);
    };
  
    const handleDropdownClick = (e) => {
      e.stopPropagation();  // Stop the click event from bubbling up
      setIsOpen(!isOpen); // Toggle the dropdown
    };
  
    return (
      <DropdownContainer>
        <DropdownButton onClick={handleDropdownClick}>
          {selectedOption || 'Select Court'}
          <Arrow isOpen={isOpen}>▸</Arrow>
        </DropdownButton>
        {isOpen && (
          <DropdownList>
            {options.map((option, index) => (
              <DropdownItem key={index} onClick={() => handleSelect(option)}>
                {option}
              </DropdownItem>
            ))}
          </DropdownList>
        )}
      </DropdownContainer>
    );
  };

export default CustomDropdown;
